import { useEffect } from 'react'
import { Moment } from 'moment'
import { DatePicker, Form, Modal, ModalProps } from 'components/common'

interface FormValues {
  target: Moment
}

export interface ExportModalProps
  extends Pick<
    ModalProps,
    'open' | 'okButtonProps' | 'cancelButtonProps' | 'onCancel'
  > {
  errors?: string[]
  onOk?: (values: FormValues) => void
}

export const ExportModal = ({
  errors,
  onOk: customOnOk,
  onCancel: customOnCancel,
  ...restProps
}: ExportModalProps): JSX.Element => {
  const [form] = Form.useForm<FormValues>()

  useEffect(() => {
    form.setFields([{ name: 'target', errors: errors }])
  }, [form, errors])

  const onOk: ModalProps['onOk'] = async (e) => {
    try {
      await form.validateFields()
      const formValues = form.getFieldsValue()
      customOnOk?.(formValues)
    } catch (e) {
      console.error(e)
    }
  }

  const onCancel: ModalProps['onCancel'] = (e) => {
    customOnCancel?.(e)
  }

  return (
    <>
      <Modal
        title="予約をエクスポートする"
        okText="エクスポートする"
        cancelText="キャンセル"
        onOk={onOk}
        onCancel={onCancel}
        {...restProps}
      >
        <Form form={form}>
          <Form.Item name="target" label="集計月" rules={[{ required: true }]}>
            <DatePicker picker="month" placeholder="集計月を選択してください" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}
